module.exports = __webpack_public_path__ + "static/media/icons-ic-calendar-picker.825e0f00.svg";